import {
  Card,
  Box,
  Stack,
  Typography,
  LinearProgress,
} from "@material-ui/core";
import { contarDetenidos } from "src/components/facturacion/estadoFacturacion";

const METRICAS = [
  { key: "total", label: "Total", color: "text.primary" },
  { key: "pendientes", label: "Pendientes", color: "text.secondary" },
  { key: "emitiendo", label: "Emitiendo", color: "warning.main" },
  { key: "emitidas", label: "Emitidas", color: "success.main" },
  {
    key: "errores",
    label: "Errores",
    color: "error.main",
    // Los detenidos ya vienen contados dentro de errores: van como desglose y no como una
    // metrica propia, para que las metricas sigan sumando el total.
    detalle: (t) =>
      t.revision > 0
        ? `${t.revision} ${t.revision === 1 ? "detenido" : "detenidos"}`
        : null,
  },
  { key: "omitidas", label: "Omitidas", color: "text.disabled" },
];

export default function ResumenFacturacion({ data, cargando }) {
  // Normaliza campo a campo (no solo el objeto completo) para no propagar NaN si
  // llegara un totales parcial.
  const tot = data?.totales ?? {};
  const t = {
    total: tot.total ?? 0,
    pendientes: tot.pendientes ?? 0,
    emitiendo: tot.emitiendo ?? 0,
    emitidas: tot.emitidas ?? 0,
    errores: tot.errores ?? 0,
    omitidas: tot.omitidas ?? 0,
    // Detenidos por reconciliacion. El conteo del backend manda; si no viniera, se deriva de
    // los items para no contradecir a las filas, que si traen la marca.
    revision: tot.revision ?? contarDetenidos(data?.items),
  };
  // Facturable = total - omitidas (las omitidas no entran al progreso).
  const facturable = Math.max(t.total - t.omitidas, 0);
  const progreso =
    facturable > 0 ? Math.round((t.emitidas / facturable) * 100) : 0;
  const facturando = data?.estado === "FACTURANDO";
  const finalizado = data?.finalizado && facturable > 0;
  // Finalizado con errores no es exito: la barra va en ambar, no verde, para no
  // dar falsa sensacion de "todo ok" cuando quedaron documentos sin emitir.
  const finalizadoConErrores = finalizado && t.errores > 0;

  return (
    <Card
      sx={{
        position: "sticky",
        top: 8,
        zIndex: 10,
        p: 2,
        boxShadow: (theme) => theme.customShadows?.z8 ?? 3,
      }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={3}
        divider={<Box sx={{ borderLeft: 1, borderColor: "divider" }} />}
        sx={{ mb: 1.5 }}
      >
        {METRICAS.map((m) => {
          const detalle = m.detalle ? m.detalle(t) : null;
          return (
            <Box key={m.key} sx={{ minWidth: 72 }}>
              <Typography variant="h5" sx={{ color: m.color }}>
                {t[m.key]}
              </Typography>
              <Typography
                variant="caption"
                color="text.secondary"
                display="block"
              >
                {m.label}
              </Typography>
              {detalle ? (
                <Typography
                  variant="caption"
                  color="warning.main"
                  display="block"
                >
                  {detalle}
                </Typography>
              ) : null}
            </Box>
          );
        })}
      </Stack>
      <Box>
        <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.5 }}>
          <Typography variant="caption" color="text.secondary">
            {finalizadoConErrores
              ? "Finalizada con errores"
              : finalizado
                ? "Facturación finalizada"
                : facturando
                  ? "Facturando…"
                  : "Avance"}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {t.emitidas} / {facturable} ({progreso}%)
          </Typography>
        </Stack>
        <LinearProgress
          variant={cargando && facturando ? "indeterminate" : "determinate"}
          value={progreso}
          color={
            finalizadoConErrores
              ? "warning"
              : finalizado
                ? "success"
                : "primary"
          }
          sx={{ height: 8, borderRadius: 1 }}
        />
      </Box>
    </Card>
  );
}
